export class Sort {

  constructor(
    public param: 'distance' | 'rating',
    public order: 'asc' | 'desc',
  ) { 
  }
  
}